import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
export var groupByParentId = function groupByParentId(makes, models, extins, filterField, optionsList) {
  var makesValues = (makes === null || makes === void 0 ? void 0 : makes.values) || [];
  var modelsValues = (models === null || models === void 0 ? void 0 : models.values) || [];
  var extinsValues = (extins === null || extins === void 0 ? void 0 : extins.values) || [];
  var isModel = filterField === "model_id";
  var isExtins = filterField === "trim_id";
  var parentIds = [];
  if (isModel) {
    modelsValues.forEach(function (model) {
      var modelParent = makesValues.find(function (parent) {
        return (parent === null || parent === void 0 ? void 0 : parent.id) === model.parent_ids[0];
      });
      if (!modelParent) return;
      if (!parentIds.includes(modelParent === null || modelParent === void 0 ? void 0 : modelParent.id)) parentIds.push(modelParent.id);
    });
    return parentIds.map(function (id) {
      var parent = makesValues.find(function (parent) {
        return parent.id === id;
      });
      var children = modelsValues.filter(function (child) {
        return child.parent_ids[0] === id;
      });
      return _objectSpread(_objectSpread({}, parent), {}, {
        values: children
      });
    });
  }
  if (isExtins) {
    extinsValues.forEach(function (ext) {
      var extParent = modelsValues.find(function (parent) {
        return parent.id === ext.parent_ids[0];
      });
      if (!extParent) return;
      if (!parentIds.includes(extParent.id)) parentIds.push(extParent.id);
    });
    return parentIds.map(function (id) {
      var model = modelsValues.find(function (parent) {
        return parent.id === id;
      });
      var make = makesValues.find(function (parent) {
        return parent.id === model.parent_ids[0];
      });
      var children = extinsValues.filter(function (child) {
        return child.parent_ids[0] === id;
      });
      if (!make || !model) {
        console.log("make", {
          make: make,
          model: model,
          extinsValues: extinsValues,
          modelsValues: modelsValues,
          makesValues: makesValues
        });
      }
      return _objectSpread(_objectSpread({}, model), {}, {
        name: "".concat(make.name, " ").concat(model.name),
        values: children
      });
    });
  }
  if (optionsList) {
    var values = optionsList.values;
    var parents = values.map(function (value) {
      return value.parent;
    });
    var uniqueItems = new Set();
    var resultArray = parents.filter(function (item) {
      var itemString = JSON.stringify(item);
      var isUnique = !uniqueItems.has(itemString);
      if (isUnique) {
        uniqueItems.add(itemString);
      }
      return isUnique;
    });
    return resultArray.map(function (parent) {
      var newValues = values.filter(function (value) {
        return value.parent.parent_id === parent.parent_id;
      });
      return _objectSpread(_objectSpread({}, parent), {}, {
        name: parent.name,
        values: newValues
      });
    });
  }
};
export var mapFacets = function mapFacets(facets) {
  var finalFacets = [];
  var makes = facets.find(function (facet) {
    return (facet === null || facet === void 0 ? void 0 : facet.filterField) === "make_id";
  });
  var models = facets.find(function (facet) {
    return (facet === null || facet === void 0 ? void 0 : facet.filterField) === "model_id";
  });
  var extensions = facets.find(function (facet) {
    return (facet === null || facet === void 0 ? void 0 : facet.filterField) === "trim_id";
  });
  facets.forEach(function (facet) {
    if ((facet === null || facet === void 0 ? void 0 : facet.filterField) === "model_id") {
      finalFacets.push(_objectSpread(_objectSpread({}, facet), {}, {
        values: groupByParentId(makes, models, extensions, facet === null || facet === void 0 ? void 0 : facet.filterField)
      }));
    } else if ((facet === null || facet === void 0 ? void 0 : facet.filterField) === "trim_id") {
      finalFacets.push(_objectSpread(_objectSpread({}, facet), {}, {
        values: groupByParentId(makes, models, extensions, facet === null || facet === void 0 ? void 0 : facet.filterField)
      }));
    } else if ((facet === null || facet === void 0 ? void 0 : facet.filterField) === "options_list") {
      finalFacets.push(_objectSpread(_objectSpread({}, facet), {}, {
        values: groupByParentId(makes, models, extensions, facet === null || facet === void 0 ? void 0 : facet.filterField, facet)
      }));
    } else {
      finalFacets.push(facet);
    }
  });
  return finalFacets;
};
export function handleFilter(filters) {
  delete filters.sort;
  delete filters.page;
  if (filters !== null && filters !== void 0 && filters.is_new && typeof (filters === null || filters === void 0 ? void 0 : filters.is_new) === "string") {
    filters.is_new = filters.is_new === "true" || filters.is_new === "1" ? 1 : 0;
  }
  if (filters !== null && filters !== void 0 && filters.odometer_to && typeof (filters === null || filters === void 0 ? void 0 : filters.odometer_to) === "string") {
    filters.odometer_to = filters.odometer_to.replaceAll(",", "");
  }
  if (filters !== null && filters !== void 0 && filters.odometer_from && typeof (filters === null || filters === void 0 ? void 0 : filters.odometer_from) === "string") {
    filters.odometer_from = filters.odometer_from.replaceAll(",", "");
  }
  filters.text = filters.text || "";
  return filters;
}